module.exports = __webpack_public_path__ + "assets/img/package-man.aef414c8.jpg";